module.exports = __webpack_public_path__ + "img/section.3e4c1962.svg";